import { Loading } from '@cibo/profile'
import { Stack } from '@mui/material'
import { useEffect } from 'react'
import { Navigate, generatePath, useNavigate, useParams } from 'react-router-dom'
import { Section } from '../../consts/Theme'
import { useProgramEngagementContext } from '../../features/ProgramEngagement'
import { ENGAGEMENT_ROUTES, EngagementRouteParams } from '../../navigation/types/engagementRoutes'
import { GROWERS_ROUTES } from '../../navigation/types/growersRoutes'
import { ProgramInfo } from './ProgramInfo'
import { Step } from './Step'
import { Task } from './Task'
import { TaskNavigation } from './TaskNavigation'

export const ProgramEngagementPlayer = () => {
  const { engagementId, stageId = 'apply', stepId, taskId } = useParams<EngagementRouteParams>()
  const { basePath, engagement } = useProgramEngagementContext()
  const navigate = useNavigate()

  useEffect(() => {
    if (!stepId && !!engagement.data) {
      if (!!engagement.data?.currentStepId) {
        navigate(
          generatePath(`${basePath}${ENGAGEMENT_ROUTES.STEP}`, {
            stageId,
            engagementId: engagement.data.id,
            stepId: engagement.data.currentStepId,
          }),
          { replace: true }
        )
      } else {
        const statusStepId = engagement.data?.getStageStatus('apply')?.children[0]?.id
        statusStepId &&
          navigate(
            generatePath(`${basePath}${ENGAGEMENT_ROUTES.STEP_STATUS}`, {
              stageId,
              engagementId: engagement.data.id,
              stepId: statusStepId,
            }),
            { replace: true }
          )
      }
    }
  }, [engagement.dataUpdatedAt, stepId])

  if (!!engagementId && engagement.isLoading) {
    return <Loading />
  }

  if (!!engagementId && engagement.isError) {
    return <Navigate to={generatePath(GROWERS_ROUTES.ROOT)} replace />
  }

  return (
    <Stack spacing={3} flex={1}>
      {!!taskId ? (
        <Task stepId={stepId} taskId={taskId} />
      ) : !!stepId ? (
        <Step />
      ) : (
        <Section sx={{ flex: 1 }}>
          <ProgramInfo />
        </Section>
      )}
      <Section flex={1}>
        <Stack direction="row" spacing={3} padding={2} justifyContent="space-between">
          <TaskNavigation />
        </Stack>
      </Section>
    </Stack>
  )
}
